import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment-timezone';
import { Moment } from 'moment-timezone';
import { Subscription } from 'rxjs/internal/Subscription';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';
import { SystemService } from '../../../../../../system/system.service';

@Component({
  selector: 'app-form-field-time',
  templateUrl: './time-form-field.component.html',
  styleUrls: ['./time-form-field.component.scss'],
  standalone: false,
})
export class TimeFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  @Input() timePlaceholder: string = 'Time';

  public dateFormat = 'hh:mm a';

  public saveDateFormat = 'HH:mm';

  public modelDate: Moment;

  public modelTime: string;

  matcher = new MyErrorStateMatcher();

  public timezone = 'UTC';

  public lastTimezone = 'UTC';

  private utcTimeZone = 'UTC';

  public formattedDate: string;

  public timezoneSubscription: Subscription;

  private initialised: boolean = false;

  constructor(
    private systemService: SystemService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnDestroy() {
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.systemService.systemTimeZoneSubject.subscribe((timezone: string) => {
      this.lastTimezone = this.timezone;
      this.timezone = timezone;

      if (!this.initialised) {
        this.formatItNow(moment().tz(this.utcTimeZone));
      } else {
        this.formatItNow(this.modelDate.tz(this.timezone));
      }
      this.onModelChange();

      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  formatItNow(dateTime: moment.Moment) {
    if (!this.data) {
      return;
    }

    const time = String(this.data).split(':');
    dateTime.set({
      hour: Number(time[0]),
      minute: Number(time[1]),
      second: 0,
    });
    this.modelDate = dateTime.tz(this.timezone);
    this.modelTime = `${this.modelDate.get('hour')}:${this.modelDate.get('minute')}`;

    this.formattedDate = moment(this.modelDate).tz(this.timezone).format(this.dateFormat);

    if (this.formGroup && this.modelDate) {
      this.formGroup.get(this.fieldConfig.name).setValue(this.modelDate.format(this.dateFormat));
    }
  }

  onModelChange() {
    if (this.formGroup && this.modelDate) {
      this.formGroup.get(this.fieldConfig.name).setValue(this.modelDate.format(this.saveDateFormat));
    }
  }

  onTimeChange(event) {
    this.modelTime = event;
    const time = event.split(':');
    this.modelDate = moment().set({
      hour: time[0],
      minute: time[1],
      second: 0,
    });
    this.onModelChange();
  }

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    const b = !formControl.value || this.getValidatorConfig(v).condition(formControl);
    return b;
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }
}
